var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.506,
    height: 49.506,
    viewBox: "0 0 49.506 49.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_134",
    "data-name": "Component 134",
    transform: "translate(0.753 0.753)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M457.474,216.344h21.3a1.618,1.618,0,0,0,1.618-1.619v-16.57a1.617,1.617,0,0,0-1.618-1.618h-21.3a1.618,1.618,0,0,0-1.619,1.618l0,16.581a1.618,1.618,0,0,1-1.618,1.619Z",
    transform: "translate(-443.875 -184.27)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M480.4,214.628v3.2a1.618,1.618,0,0,1-1.618,1.619h-21.3a1.619,1.619,0,0,1-1.619-1.619v-1.667",
    transform: "translate(-443.875 -184.27)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    x2: 24.226,
    transform: "translate(12.296 16.027)",
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913",
    transform: "translate(-443.875 -184.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    y2: 2.521,
    transform: "translate(461.547 195.513)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    y2: 2.521,
    transform: "translate(474.18 195.513)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M464.535,208.952l2.183,2.36,5.878-6.236",
    transform: "translate(-443.875 -184.27)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesCircleIcon);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };